export default function PHP_affected_rows() {
  return (
    <div>
      <h1>PHP_affected_rows</h1>
    </div>
  );
}
